import _sectionClasses from './Page/Sections/index';
import _buttonClasses from './ButtonClasses';
import StandardGroupView from '../1/Page/Groups/StandardGroupView';

const GroupViews = {
  standard: StandardGroupView
};

export {_sectionClasses, _buttonClasses, GroupViews};
